import queryString from 'query-string';
import { isEmpty } from 'lodash';
import {
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_LIST,
  DHCI_OPT_OPTIONS,
  PRIMERA_OPT_OPTIONS,
  PRODUCT_ID_OAAS,
  PRODUCT_ID_ALLETRAB10K,
  PRODUCT_ID_FILE,
  PRODUCT_ID_PCBE,
} from '../constants';

export const historyPush = (url, location, history) => {
  const urlSearchString = location ? location.search : '';
  history.push({
    pathname: url,
    search: urlSearchString,
  });
};

export const getQueryStringValues = location => {
  const urlSearchString = location ? location.search : '';
  return queryString.parse(urlSearchString);
};

export const ChangeQueryString = (newValue, location, history) => {
  const urlSearchString = location ? location.search : '';
  let values = queryString.parse(urlSearchString);
  values = isEmpty(newValue) ? {} : { ...values, ...newValue };
  const searchString = queryString.stringify(values);
  history.replace({
    pathname: location.path,
    search: searchString,
  });
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getQueryString = location => {
  return location ? location.search : '';
};

export const getPageName = location => {
  if (!location) {
    return '';
  }
  const pathNames = location.pathname.split('/');
  let pageName = pathNames[pathNames.length - 1];
  if (pageName.match(/\D/) === null) {
    // if pageName contains only digits, it is step number in wizard page
    pageName = `${pathNames[pathNames.length - 2]}-${pathNames[pathNames.length - 1]}`;
  }

  return pageName;
};

export const validatePageQueryString = (location, history) => {
  const urlSearchString = location ? location.search : '';
  const qsValues = queryString.parse(urlSearchString);
  const product = qsValues['product'];
  // product name validation
  if (!PRODUCT_ID_LIST.includes(product)) {
    history.replace('/');
    return;
  }

  const pathName = location.pathname;
  // select-mode page will not validate the model & green/brown selection
  if (pathName.indexOf('getting-started/select-model') !== -1) {
    return;
  }

  let selectModePageUrl = '/getting-started/select-model';
  const model = qsValues['model'];
  if (product === PRODUCT_ID_OAAS || product === PRODUCT_ID_ALLETRAB10K) {
    const storagepurchaseopt = qsValues['storagepurchaseopt'];
    const connectopt = qsValues['connectopt'];
    const opt = qsValues['opt'];
    let newValues = '';
    let newQs = '';
    let boolErrorMsg = false;
    if (product === PRODUCT_ID_OAAS && storagepurchaseopt && model && !connectopt) {
      newValues = { connectopt: '' };
      boolErrorMsg = true;
    } else if (product === PRODUCT_ID_ALLETRAB10K) {
      if (!connectopt && !opt) {
        newValues = { connectopt: '', opt: '' };
        boolErrorMsg = true;
      } else if (!connectopt) {
        newValues = { connectopt: '' };
        boolErrorMsg = true;
      } else if (!opt) {
        newValues = { opt: '' };
        boolErrorMsg = true;
      }
    }
    if (boolErrorMsg) {
      newQs = { ...qsValues, ...newValues };
      history.replace({
        pathname: selectModePageUrl,
        search: queryString.stringify(newQs),
      });
      return;
    }
  }
  if (product === PRODUCT_ID_FILE || product === PRODUCT_ID_PCBE) {
    const storagepurchaseopt = qsValues['storagepurchaseopt'];
    if (!storagepurchaseopt) {
      let newValues = { storagepurchaseopt: '' };
      if (!model) {
        newValues = { storagepurchaseopt: '', model: '' };
      }
      const newQs = { ...qsValues, ...newValues };
      history.replace({
        pathname: selectModePageUrl,
        search: queryString.stringify(newQs),
      });
      return;
    }
  }
  if (!model) {
    const newValues = { model: '' };
    const newQs = { ...qsValues, ...newValues };
    history.replace({
      pathname: selectModePageUrl,
      search: queryString.stringify(newQs),
    });
    return;
  }
  switch (product) {
    case PRODUCT_ID_DHCI:
    case PRODUCT_ID_PRIMERA: {
      const pageOpt = qsValues['opt'];
      const pageOpts = product === PRODUCT_ID_DHCI ? DHCI_OPT_OPTIONS : PRIMERA_OPT_OPTIONS;
      if (!pageOpt || !pageOpts.includes(pageOpt)) {
        const newValues = { opt: '' };
        const newQs = { ...qsValues, ...newValues };
        history.replace({
          pathname: selectModePageUrl,
          search: queryString.stringify(newQs),
        });
      }
      break;
    }
    default:
      break;
  }
};

export const validateSelectors = ({ location, history, modelList }) => {
  const urlSearchString = location ? location.search : '';
  const qsValues = queryString.parse(urlSearchString);
  const product = qsValues['product'];
  const model = qsValues['model'];
  const modelDocConfig = modelList[model];
  const selectModePageUrl = '/getting-started/select-model/';
  const storagepurchaseopt = qsValues['storagepurchaseopt'];
  const connectopt = qsValues['connectopt'];
  const opt = qsValues['opt'];
  if (!modelDocConfig) {
    let newValues = { model: '' };
    if (product === PRODUCT_ID_OAAS && storagepurchaseopt && model) {
      newValues = { connectopt: '' };
    } else if (product === PRODUCT_ID_ALLETRAB10K && !model && !connectopt && !opt) {
      newValues = { model: '', connectopt: '', opt: '' };
    } else if (product === PRODUCT_ID_ALLETRAB10K && model && !connectopt && !opt) {
      newValues = { connectopt: '', opt: '' };
    } else if ((product === PRODUCT_ID_FILE || product === PRODUCT_ID_PCBE) && !storagepurchaseopt) {
      newValues = { storagepurchaseopt: '', model: '' };
    }
    const newQs = { ...qsValues, ...newValues };
    history.replace({
      pathname: selectModePageUrl,
      search: queryString.stringify(newQs),
    });
    return false;
  } else {
    switch (product) {
      case PRODUCT_ID_DHCI:
      case PRODUCT_ID_PRIMERA: {
        const pageOpt = qsValues['opt'];
        const pageOpts = product === PRODUCT_ID_DHCI ? DHCI_OPT_OPTIONS : PRIMERA_OPT_OPTIONS;
        if (!pageOpts.includes(pageOpt)) {
          const newValues = { opt: '' };
          const newQs = { ...qsValues, ...newValues };
          history.replace({
            pathname: selectModePageUrl,
            search: queryString.stringify(newQs),
          });
        }
        break;
      }
      default:
        break;
    }
    return true;
  }
};
